import { IconClipboard } from '@medifind/icons';
import { useRouter } from '@medifind/router';
import AdWrapper from './adWrapper';

const SymptomCheckerAd = ({ ...props }) => {
  const router = useRouter();
  return (
    <AdWrapper
      {...props}
      icon={<IconClipboard fill="#761E91" size={'small'} />}
      title={'Not sure about your diagnosis?'}
      onClick={() => router.history.push('/symptom-checker')}
      buttonText={'Check Your Symptoms'}
    />
  );
};

export { SymptomCheckerAd as default, SymptomCheckerAd };
